export default [{
    path: "/ads/adsbudget",
    name: "adsbudget",
    component: () => import("@/views/ads/adsBudget/AdsBudgetList.vue"),
    meta: {
      // requiresAuth: true,
      pageTitle: "Ads Budget List",
      action: "view",
      resource: "adsbudget",
      breadcrumb: [
        {
          text: "Ads Budget",
          active: true
        }
      ]
    }
  },{
    path: "/ads/ads-summary",
    name: "ads-summary",
    component: () => import("@/views/ads/adsSummary/AdsSummaryList.vue"),
    meta: {
      // requiresAuth: true,
      pageTitle: "Budget Summary",
      action: "view",
      resource: "ads-summary",
      breadcrumb: [
        {
          text: "Ads Summary",
          active: true
        }
      ]
    }
  },
]